import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { MultiStepModal } from "../../../modals/multi_step_modals/multi_step_modal";
import { acceptAndUploadConfig } from "./script_and_upload";
import { reviewPreRecordConfig } from "./accept_pre_recorded";
import { successPageConfig } from "./success";
import { nextStepsConfig } from "./next_steps";
import { confirmMailingPageConfig } from "./confirm_mailing";
import { useDispatch } from "react-redux";
import isEmpty from "lodash/isEmpty";
import {
  CampaignItemStateAwaitingAudio,
  CampaignStyleCampaignAudio,
  CampaignStyleHostRead,
  ProductExchangeTypeInstructions,
  ProductExchangeTypeMailing,
  ProductExchangeTypeNone,
} from "../../../../constants/campaigns";
const pagesFromMode = props => {
  //we can't go off of the state of the campaign item because it changes in the lifetime of this modal
  if (props.isAwaitingAudio) {
    return [acceptAndUploadConfig({ ...props, includeUpload: true }), successPageConfig(props)];
  }
  let { style, productExchangeType } = props.campaign;
  if (!productExchangeType) productExchangeType = "none";
  switch (`${style}|${productExchangeType}`) {
    case `${CampaignStyleCampaignAudio}|${ProductExchangeTypeNone}`:
      return [reviewPreRecordConfig(props), successPageConfig(props)];
    case `${CampaignStyleCampaignAudio}|${ProductExchangeTypeInstructions}`:
      return [reviewPreRecordConfig(props), successPageConfig(props)];
    case `${CampaignStyleCampaignAudio}|${ProductExchangeTypeMailing}`:
      return [
        confirmMailingPageConfig(props),
        reviewPreRecordConfig(props),
        successPageConfig(props),
      ];
    case `${CampaignStyleHostRead}|${ProductExchangeTypeInstructions}`:
      return [acceptAndUploadConfig({ ...props, includeUpload: false }), nextStepsConfig(props)];
    case `${CampaignStyleHostRead}|${ProductExchangeTypeNone}`:
      return [acceptAndUploadConfig({ ...props, includeUpload: true }), successPageConfig(props)];
    case `${CampaignStyleHostRead}|${ProductExchangeTypeMailing}`:
      return [
        confirmMailingPageConfig(props),
        acceptAndUploadConfig({ ...props, includeUpload: false }),
        nextStepsConfig(props),
      ];
    default:
      return [];
  }
};

const AcceptAdvertisementModal = ({
  hideModal,
  campaign,
  campaignItem,
  creatorAmount,
  show,
  isAwaitingAudio,
  history,
}) => {
  const [step, setStep] = useState(0);
  const [mediaFileUUID, setMediaFileUUID] = useState();
  const dispatch = useDispatch();
  if (!campaign || isEmpty(campaign)) return null;
  const close = () => {
    // this looks weird but this is the state after someone just accepted, and has not clicked on the upload version of the modal
    if (campaignItem.state === CampaignItemStateAwaitingAudio && !isAwaitingAudio) {
      history.push(`/shows/${show.uuid}/advertising`);
    }
    hideModal();
  };
  return (
    <MultiStepModal
      pageNumber={step}
      onUpdatePage={setStep}
      hideTitleDivider={true}
      pages={pagesFromMode({
        campaign,
        campaignItem,
        creatorAmount,
        show,
        setMediaFileUUID,
        mediaFileUUID,
        dispatch,
        isAwaitingAudio,
      })}
      commonSettings={{
        showContent: true,
      }}
      close={close}
    />
  );
};

export default withRouter(AcceptAdvertisementModal);
